import { useIntl } from 'react-intl';
import { TradeContext } from '../../types/trade';
import NegotiationState from '../../constants/negotiationState';

const useNegotiationOfferLabels = (
  negotiationState,
  tradeContext,
  isGreyOut
) => {
  const intl = useIntl();

  let offerTitle = null;
  let actionRequired = false;
  let highlightBidValue = false;
  let highlightBidLabel = false;

  if (tradeContext === TradeContext.Sell) {
    if (
      negotiationState === NegotiationState.SELLER_OFFER ||
      negotiationState === NegotiationState.SELLER_COUNTER
    ) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.seller.label.sellerOffer'
      });
    } else if (negotiationState === NegotiationState.BUYER_OFFER) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.seller.label.buyerOffer'
      });
      actionRequired = true;
      highlightBidValue = true;
    } else if (negotiationState === NegotiationState.BUYER_COUNTER) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.seller.label.buyerCounter'
      });
      actionRequired = true;
      highlightBidValue = true;
    } else if (negotiationState === NegotiationState.FINAL_ASKING_PRICE) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.seller.label.finalAskingPrice'
      });
    } else if (negotiationState === NegotiationState.BUYER_FIRM) {
      actionRequired = true;
      highlightBidValue = true;
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.seller.label.buyerFirm'
      });
    } else if (negotiationState === NegotiationState.DECLINED) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.seller.label.finalAskingPrice'
      });
    }
  } else if (tradeContext === TradeContext.Buy) {
    if (negotiationState === NegotiationState.BUYER_OFFER) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.buyer.label.buyerOffer'
      });
    } else if (negotiationState === NegotiationState.BUYER_COUNTER) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.buyer.label.buyerCounter'
      });
    } else if (negotiationState === NegotiationState.SELLER_OFFER) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.buyer.label.newAsking'
      });
      actionRequired = true;
      highlightBidValue = true;
    } else if (negotiationState === NegotiationState.SELLER_COUNTER) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.buyer.label.sellerCounter'
      });
      actionRequired = true;
      highlightBidValue = true;
    } else if (
      negotiationState === NegotiationState.FINAL_ASKING_PRICE &&
      isGreyOut
    ) {
      actionRequired = true;
      highlightBidValue = true;
      highlightBidLabel = true;
      offerTitle = intl.formatMessage({ id: 'vdp.pending.buyer.declined' });
    } else if (negotiationState === NegotiationState.FINAL_ASKING_PRICE) {
      actionRequired = true;
      highlightBidValue = true;
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.buyer.label.finalAskingPrice'
      });
    } else if (negotiationState === NegotiationState.BUYER_FIRM) {
      offerTitle = intl.formatMessage({
        id: 'vdp.pending.buyer.label.buyerFirm'
      });
      highlightBidValue = true;
    } else if (
      negotiationState === NegotiationState.DECLINED ||
      negotiationState === NegotiationState.ACCEPTED
    ) {
      offerTitle = intl.formatMessage({ id: 'vdp.pending.buyer.declined' });
      highlightBidValue = true;
      highlightBidLabel = true;
    }
  }

  return [offerTitle, actionRequired, highlightBidValue, highlightBidLabel];
};

export default useNegotiationOfferLabels;
